const resultsCollation = {
  en: {
    resultsCollationPage: {
      pollingStations: "Polling Stations",
      votesCast: "Votes Cast",
      validVotes: "Valid Votes",
      rejected: "Rejected",
      coverage: "Coverage",
      coveragePct: "{{value}}% coverage",
      noCandidateResults: "No candidate results available",
      unknown: "Unknown",
      na: "N/A",
      candidateResults: "Candidate Results",
      leading: "Leading",
      voteDistribution: "Vote Distribution",
      nationalPresidential: "National Collation - Presidential Election",
      nationalPresidentialDesc: "Aggregated results from all 10 regions of Cameroon",
      backToAllRegions: "Back to All Regions",
      regionalCollationRegion: "Regional Collation - {{region}}",
      regionalPresidential: "Regional Collation - Presidential Election",
      regionalPresidentialDesc: "Results breakdown by region",
      stations: "Stations",
      verified: "Verified",
      backToDivisions: "Back to Divisions",
      divisionalCollationDetail: "Divisional Collation - {{division}}, {{region}}",
      subdivisionBreakdown: "Subdivision Breakdown",
      votesStations: "{{votes}} votes • {{stations}} stations",
      divisionalPresidential: "Divisional Collation - Presidential Election",
      divisionalPresidentialDesc: "Results breakdown by division",
      filterByRegion: "Filter by region",
      allRegions: "All Regions",
      region: "Region",
      division: "Division",
      valid: "Valid",
      action: "Action",
      back: "Back",
      regionalElectionRegion: "Regional Election - {{region}}",
      divisionBreakdown: "Division Breakdown",
      votesCount: "{{count}} votes",
      stationsCount: "{{count}} stations",
      verifiedCount: "{{count}} verified",
      regionalElectionResults: "Regional Election Results",
      regionalElectionsNote: "Regional elections are held only in North-West and South-West regions",
      regionName: "{{region}} Region",
      nationalCouncil: "National Collation - Council Elections",
      nationalCouncilDesc: "Aggregated results from all 357 councils of Cameroon",
      totalCouncils: "Total Councils",
      councilsDecided: "Councils Decided",
      totalSeats: "Total Seats",
      seatsDecided: "Seats Decided",
      councilsWonByParty: "Councils Won by Party",
      councilsWonDesc: "Each council winner is determined independently",
      councilsWon: "Councils Won",
      noResultsYet: "No results yet",
      partyPerformance: "Party Performance",
      pctCouncilsWon: "Percentage of councils won",
      councilsPct: "{{count}} councils ({{pct}}%)",
      regionalBreakdownCouncil: "Regional Breakdown - Council Elections",
      regionalBreakdownCouncilDesc: "Council election results by region",
      councils: "Councils",
      leadingParty: "Leading Party",
      nationalSenatorial: "National Collation - Senatorial Elections",
      senatorialSummary: "10 Regions • 7 Seats per Region • Total 70 Seats",
      totalRegions: "Total Regions",
      regionsDecided: "Regions Decided",
      seatsWonByParty: "Seats Won by Party",
      seatsWonDesc: "Winner-takes-all: 7 seats per region won",
      seatsWon: "Seats Won",
      regionsWon: "Regions Won",
      pctSeatsWon: "Percentage of seats won",
      seatsPct: "{{count}} seats ({{pct}}%)",
      regionalBreakdownSenatorial: "Regional Breakdown - Senatorial Elections",
      regionalBreakdownSenatorialDesc: "Results by region (7 seats per region)",
      leader: "Leader",
      seats: "Seats",
      totalVotes: "Total Votes",
      status: "Status",
      awaitingResults: "Awaiting results",
      sevenSeats: "7 seats at stake",
      title: "Election Results Collation",
      subtitle: "Multi-tier election results statistics",
      shareTitle: "EReMS - {{type}} Election Results",
      shareText: "Live {{type}} election results from Cameroon on EReMS! 🗳️",
      electionType: "Election Type",
      national: "National",
      regional: "Regional",
      divisional: "Divisional",
      electionTypes: {
        presidential: "Presidential", parliamentary: "Parliamentary", senatorial: "Senatorial",
        regional: "Regional", council: "Council"
      },
      regionalNWSW: "Regional (NW/SW)",
      councilElections: "Council Elections",
      statuses: {
        pending: "pending", decided: "decided", verified: "verified", disputed: "disputed",
        approved: "approved", certified: "certified", rejected: "rejected"
      }
    }
  },
  fr: {
    resultsCollationPage: {
      pollingStations: "Bureaux de vote",
      votesCast: "Votes exprimés",
      validVotes: "Votes valides",
      rejected: "Rejetés",
      coverage: "Couverture",
      coveragePct: "{{value}}% de couverture",
      noCandidateResults: "Aucun résultat de candidat disponible",
      unknown: "Inconnu",
      na: "N/D",
      candidateResults: "Résultats des candidats",
      leading: "En tête",
      voteDistribution: "Répartition des votes",
      nationalPresidential: "Compilation nationale - Élection présidentielle",
      nationalPresidentialDesc: "Résultats agrégés des 10 régions du Cameroun",
      backToAllRegions: "Retour à toutes les régions",
      regionalCollationRegion: "Compilation régionale - {{region}}",
      regionalPresidential: "Compilation régionale - Élection présidentielle",
      regionalPresidentialDesc: "Répartition des résultats par région",
      stations: "Bureaux",
      verified: "Vérifiés",
      backToDivisions: "Retour aux départements",
      divisionalCollationDetail: "Compilation départementale - {{division}}, {{region}}",
      subdivisionBreakdown: "Détail par arrondissement",
      votesStations: "{{votes}} votes • {{stations}} bureaux",
      divisionalPresidential: "Compilation départementale - Élection présidentielle",
      divisionalPresidentialDesc: "Répartition des résultats par département",
      filterByRegion: "Filtrer par région",
      allRegions: "Toutes les régions",
      region: "Région",
      division: "Département",
      valid: "Valides",
      action: "Action",
      back: "Retour",
      regionalElectionRegion: "Élection régionale - {{region}}",
      divisionBreakdown: "Détail par département",
      votesCount: "{{count}} votes",
      stationsCount: "{{count}} bureaux",
      verifiedCount: "{{count}} vérifiés",
      regionalElectionResults: "Résultats de l'élection régionale",
      regionalElectionsNote: "Les élections régionales ne se tiennent que dans les régions du Nord-Ouest et du Sud-Ouest",
      regionName: "Région {{region}}",
      nationalCouncil: "Compilation nationale - Élections municipales",
      nationalCouncilDesc: "Résultats agrégés des 357 communes du Cameroun",
      totalCouncils: "Total des communes",
      councilsDecided: "Communes tranchées",
      totalSeats: "Total des sièges",
      seatsDecided: "Sièges attribués",
      councilsWonByParty: "Communes remportées par parti",
      councilsWonDesc: "Le vainqueur de chaque commune est déterminé indépendamment",
      councilsWon: "Communes remportées",
      noResultsYet: "Aucun résultat pour le moment",
      partyPerformance: "Performance des partis",
      pctCouncilsWon: "Pourcentage de communes remportées",
      councilsPct: "{{count}} communes ({{pct}}%)",
      regionalBreakdownCouncil: "Détail régional - Élections municipales",
      regionalBreakdownCouncilDesc: "Résultats des élections municipales par région",
      councils: "Communes",
      leadingParty: "Parti en tête",
      nationalSenatorial: "Compilation nationale - Élections sénatoriales",
      senatorialSummary: "10 régions • 7 sièges par région • 70 sièges au total",
      totalRegions: "Total des régions",
      regionsDecided: "Régions tranchées",
      seatsWonByParty: "Sièges remportés par parti",
      seatsWonDesc: "Le vainqueur emporte tout : 7 sièges par région remportée",
      seatsWon: "Sièges remportés",
      regionsWon: "Régions remportées",
      pctSeatsWon: "Pourcentage de sièges remportés",
      seatsPct: "{{count}} sièges ({{pct}}%)",
      regionalBreakdownSenatorial: "Détail régional - Élections sénatoriales",
      regionalBreakdownSenatorialDesc: "Résultats par région (7 sièges par région)",
      leader: "Chef de file",
      seats: "Sièges",
      totalVotes: "Total des votes",
      status: "Statut",
      awaitingResults: "En attente des résultats",
      sevenSeats: "7 sièges en jeu",
      title: "Compilation des résultats électoraux",
      subtitle: "Statistiques des résultats électoraux à plusieurs niveaux",
      shareTitle: "EReMS - Résultats de l'élection {{type}}",
      shareText: "Résultats en direct de l'élection {{type}} au Cameroun sur EReMS ! 🗳️",
      electionType: "Type d'élection",
      national: "National",
      regional: "Régional",
      divisional: "Départemental",
      electionTypes: {
        presidential: "Présidentielle", parliamentary: "Législative", senatorial: "Sénatoriale",
        regional: "Régionale", council: "Municipale"
      },
      regionalNWSW: "Régionale (NO/SO)",
      councilElections: "Élections municipales",
      statuses: {
        pending: "en attente", decided: "tranché", verified: "vérifié", disputed: "contesté",
        approved: "approuvé", certified: "certifié", rejected: "rejeté"
      }
    }
  }
};

export default resultsCollation;
